import React from 'react'
import { Col, Row, Spin, Select, Button, Tabs, Space } from "antd";
import { MailOutlined, PhoneFilled } from "@ant-design/icons";
import { DB_TYPE } from '../Firestore';
import { VERSION } from '../Constant';
import '../common-style.css';

import { Link } from 'react-router-dom';

export default function FooterInfo(props) {
    return (
        <>
            <div className="footer">
                Copyright © 2024 Teddy Game Mobile Ltd. - ver_{VERSION}- Database: {DB_TYPE} |

                <Link to="/privacy" style={{ marginLeft: 8 }}>Chính sách và điều khoản</Link>
            </div>
        </>
    )
}